/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import orderService from '@/services/order';
import Vue from 'vue';
import orderState from '@/utils/orderState';
import numeral from 'numeral';
import _ from 'lodash';
import moment from 'moment';
import storageService from '@/services/storage';
import { encodePathSegment } from '@/utils/url';

const firstDate = new Date('January 01, 2016 01:00:00');

const combineDateAndTime = function (date, time) {
  const timeString = `${time.getHours()}:${time.getMinutes()}:00`;

  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Jan is 0, dec is 11
  const day = date.getDate();
  const dateString = `${year}-${month}-${day}`;
  const combined = new Date(`${dateString} ${timeString}`);

  return combined;
};

const getContainerUrl = path =>
  `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/${path}`;

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
  },
  mounted() {
    this.fetchOrders();
  },
  data() {
    return {
      filter: {
        limit: 10,
        skip: 0,
        order: 'id DESC',
        where: {},
      },
      cfForm: {
        orderId: null,
        billNumber: null,
      },
      imageActionURL: getContainerUrl('upload'),
      imgDialog: false,
      dialogImgUrl: '',
      debounceObj: null,
      selectedGroup: {},
      pageSize: 10,
      selectedPage: 1,
      selectedOrder: {},
      deleteDialog: false,
      confirmPayment: false,
      fileList: [],
      tempFilter: {
        orderNum: null,
        billNumber: null,
        customerPhoneNumber: null,
      },
      whereFilter: {
        orderNum: null,
        billNumber: null,
        customerPhoneNumber: null,
        dateRange: [],
      },
    };
  },
  computed: {
    imageHeaders() {
      return {
        Authorization: store.state.auth.token,
      };
    },
    orders() {
      const orders = store.state.order.orders;
      for (const o of orders) {
        if (o.orderState) {
          o.orderStatePaid = o.orderState === 1;
          o.orderStateText = orderState.get(o.orderState).key;
        }
      }
      return orders;
    },
    count() {
      return store.state.order.count;
    },
    token() {
      return store.state.auth.token;
    },
  },
  filters: {
    formatzero(val) {
      return numeral(val).format('0,0.00');
    },
  },
  watch: {
    whereFilter: {
      handler(newValue) {
        if (!this.filter.where) {
          this.filter.where = {};
        }
        this.filter.where.and = [];

        if (newValue.orderNum) {
          this.filter.where.and.push({
            orderNum: {
              like: `%${newValue.orderNum}%`
            }
          });
        }

        if (newValue.billNumber) {
          this.filter.where.and.push({
            billNumber: {
              like: `%${newValue.billNumber}%`
            }
          });
        }

        if (newValue.customerPhoneNumber) {
          this.filter.where.and.push({
            customerPhoneNumber: {
              like: `%${newValue.customerPhoneNumber}%`
            },
          });
        }

        if (newValue.dateRange.length > 0) {
          this.filter.where.and.push({
            deliveryDate: {
              between: newValue.dateRange
            },
          });
        } else {
          this.filter.where.and = _.filter(this.filter.where.and, (c) => {
            if (c.deliveryDate) {
              return false;
            }
            return true;
          });
        }

        this.fetchOrders();
      },
      deep: true,
    },
  },
  methods: {
    openPaidDialog(idx) {
      this.confirmPayment = true;
      this.cfForm = JSON.parse(JSON.stringify(this.orders[idx]));
      this.cfForm.billNumber = '';
      this.cfForm.paidTime = new Date();
    },
    filterPaid() {
      if (!this.filter.where) {
        this.filter.where = {};
      }

      if (!this.filter.where.and) {
        this.filter.where.and = [];
      }

      this.filter.where.and = _.filter(this.filter.where.and, (c) => {
        if (c.orderState) {
          return false;
        }
        return true;
      });

      this.filter.where.and.push({
        orderState: orderState.get('paid').value,
      });

      this.fetchOrders();
    },
    filterUnpaid() {
      if (!this.filter.where) {
        this.filter.where = {};
      }

      if (!this.filter.where.and) {
        this.filter.where.and = [];
      }

      this.filter.where.and = _.filter(this.filter.where.and, (c) => {
        if (c.orderState) {
          return false;
        }
        return true;
      });

      this.filter.where.and.push({
        orderState: orderState.get('unpaid').value,
      });

      this.fetchOrders();
    },
    handleImageUploaded(response) {
      if (!this.cfForm.billImages) {
        this.cfForm.billImages = [];
      }
      this.cfForm.billImages.push(response.result.files.file[0].name);
    },
    resetFilters() {
      this.whereFilter = {
        orderNum: null,
        billNumber: null,
        customerPhoneNumber: null,
        dateRange: [],
      };

      this.tempFilter = {
        orderNum: null,
        billNumber: null,
        customerPhoneNumber: null,
      };

      this.fetchOrders();
    },
    fetchPage() {
      this.fetchOrders();
    },
    async fetchOrders() {
      store.dispatch('order/getOrders', {
        filter: this.filter,
      });
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.recalculateFilter();
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.recalculateFilter();
      this.fetchPage();
    },
    recalculateFilter() {
      this.filter.limit = this.pageSize;
      this.filter.skip = (this.selectedPage - 1) * this.pageSize;
    },
    confirmDelete(order) {
      this.selectedOrder = order;
      this.deleteDialog = true;
      this.fetchPage();
    },
    async deleteSelectedOrder() {
      this.deleteDialog = false;
      try {
        await orderService.del(this.selectedOrder);
        this.fetchPage();
      } catch (e) {
        console.error(e);
      }
    },
    navigate(data) {
      Vue.router.push(data);
    },
    getInvoiceUrl(path, data) {
      if (data.invoiceToken) {
        return `${process.env.API_LOCATION}api/Orders/${encodePathSegment(path)}/${encodePathSegment(data.id)}?token=${encodeURIComponent(
          data.invoiceToken,
        )}`;
      }

      return `${process.env.API_LOCATION}api/Orders/${encodePathSegment(path)}/${encodePathSegment(data.id)}?access_token=${encodeURIComponent(
        this.token,
      )}`;
    },
    print(data) {
      window.open(this.getInvoiceUrl('viewInvoice', data));
    },
    handleClose() {
      this.confirmPayment = false;
    },
    download(data) {
      window.open(this.getInvoiceUrl('downloadInvoice', data));
    },
    async markAsPaid(form) {
      try {
        await this.createEvent(form);
        form.orderState = orderState.get('paid').value;
        orderService.edit(form).then(() => {
          this.confirmPayment = false;
          this.fetchPage();
        });
      } catch (e) {
        console.log(e);
      }
    },
    debounceInput(i, e) {
      const vueObj = this;

      if (this.debounceObj) {
        clearTimeout(this.debounceObj);
      }

      this.debounceObj = setTimeout(() => {
        vueObj.whereFilter[i] = e;
      }, 500);
    },
    handlePictureCardPreview(file) {
      this.imgDialog = true;
      this.dialogImgUrl = file.url;
    },
    handleRemove(file) {
      this.form.images = this.form.images.filter(img => img !== file.filename);
      storageService.del(file.filename);
    },
    async createEvent(data) {
      if (!data.deliveryTimeStart || !data.deliveryTimeEnd) {
        this.$alert('กรุณาทำการตั้งเวลาจัดส่งก่อน ถึงจะสามารถทำการยืนยันได้', 'กรุณาตั้งเวลา', {
          confirmButtonText: 'OK',
          callback: () => {},
        });
        return;
      }
      const eventObject = {
        event: {
          summary: `#${data.orderNum}`,
          description: `หมายเลข: ${data.billNumber}\nลูกค้า: ${data.customerName}\nประเภท: ${
            data.deliveryType
          }\nสถานที่ส่งของ: ${data.deliveryName}`,
          start: {
            dateTime: combineDateAndTime(
              new Date(data.deliveryDate),
              new Date(data.deliveryTimeStart),
            ),
            timeZone: 'Asia/Bangkok',
          },
          end: {
            dateTime: combineDateAndTime(
              new Date(data.deliveryDate),
              new Date(data.deliveryTimeEnd),
            ),
            timeZone: 'Asia/Bangkok',
          },
        },
      };
      return new Promise(async (resolve, reject) => {
        let result = await orderService.createEvent(eventObject);
        result = result.data;

        if (result.event && result.event.authUrl) {
          window.open(result.event.authUrl, '_blank');
          this.$alert(
            'กรุณาทำการกดยินยอมให้ทำการดัดแปลงปฎิทิน google ของท่าน หลังจากกดยินยอมเสร็จแล้วให้กลับมากดปุ่มนี้ใหม่',
            'ทำการให้โปรแกรมสามารถดัดแปลงปฎิทิน', {
              confirmButtonText: 'OK',
              callback: (action) => {
                reject('need authen');
                this.$message({
                  type: 'info',
                  message: `action: ${action}`,
                });
              },
            },
          );
        } else if (result.event.status === 'confirmed') {
          resolve('success');
          this.$message({
            message: 'สร้าง Event ในปฎิทินของท่านเรียบร้อยแล้ว',
            type: 'success',
          });
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/order/view/index.js